module.exports = __webpack_public_path__ + "assets/media/purple_arrow.1aabb7e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/purple_arrow.svg
// module id = 2872
// module chunks = 0